module.exports = "/legacy/b896b9eaeed6f65345b644ad6a67dfa8.svg";